import reduceReducers from 'reduce-reducers'

import { default as PolicyReducer } from './policy'
import { default as PolicyDocReducer } from './policyDoc'

export * from './policy'
export * from './policyDoc'

// Export types and initialState from separate file to avoid circular dependencies
import { types, initialState } from './types'
export { types, initialState }
export default reduceReducers(
  PolicyReducer,
  PolicyDocReducer,
  // the last arg MUST be the shared state
  initialState,
)
